import { render, staticRenderFns } from "./CardPropertiesList.vue?vue&type=template&id=29d0bf38"
import script from "./CardPropertiesList.vue?vue&type=script&lang=js"
export * from "./CardPropertiesList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports